export default [
  {
    value: 'title',
    text: 'Название рекламного места',
    type: 'string',
    description: ''
  },
  {
    value: 'slotId',
    text: 'ID',
    width: 80,
    type: 'string',
    description: ''
  },
  {
    value: 'height',
    text: 'Высота',
    width: 160,
    type: 'string',
    string: ''
  },
  {
    value: 'width',
    text: 'Ширина',
    width: 160,
    type: 'string',
    string: ''
  },
  {
    value: 'url',
    text: 'Iframe URL',
    type: 'string',
    string: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 105,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
